import Tracker from '@openreplay/tracker';

let tracker = null;

// Create a shared tracker instance
if (process.env.REACT_APP_STAGE === 'prod' && process.env.NODE_ENV === 'production') {
    tracker = new Tracker({
        projectKey: "Q7BRVqXP6gZOFbNVpanU",
        ingestPoint: "https://openreplay.languify.in/ingest",
        network: {
            failuresOnly: false, // Capture all network requests, not just failures
            capturePayload: true, // Capture request and response payloads
            captureInIframes: true, // Capture network requests made within iframes
        }
    });
}

const initOpenReplay = () => {
    if (tracker) tracker.start();
};

export { tracker, initOpenReplay };
